import { getAsync } from './_base';

const getLogout = (loginApiUrl?: string) => {
  return getAsync(loginApiUrl ?? '');
};

const getClearBaket = (clearBasketApiUrl?: string) => {
  return getAsync(clearBasketApiUrl ?? '');
};

export { getLogout, getClearBaket };
